import type { VersionedJson } from '@builder4/shared/migrations/types';

const HEADING_LEVELS = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] as const;

interface TypographyStyle {
  textAlign?: unknown;
  fontStyle?: unknown;
  [key: string]: unknown;
}

interface Typography {
  heading?: Record<string, TypographyStyle>;
  body?: TypographyStyle;
  [key: string]: unknown;
}

interface DataWithTypography extends VersionedJson {
  typography?: Typography;
}

const removeDeprecatedFields = (style: TypographyStyle): TypographyStyle => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { textAlign, fontStyle, ...rest } = style;
  return rest;
};

export default function toV2<T extends VersionedJson>(data: T): T {
  const typedData = data as DataWithTypography;
  const typography = typedData.typography;
  if (!typography || typeof typography !== 'object') {
    return data;
  }

  const heading = typography.heading;
  let newHeading: Record<string, TypographyStyle> | undefined;
  if (heading && typeof heading === 'object') {
    newHeading = { ...heading };
    for (const level of HEADING_LEVELS) {
      const headingLevel = heading[level];
      if (headingLevel && typeof headingLevel === 'object') {
        newHeading[level] = removeDeprecatedFields(headingLevel);
      }
    }
  }

  const body = typography.body;
  const newBody = body && typeof body === 'object' ? removeDeprecatedFields(body) : body;

  return {
    ...data,
    typography: {
      ...typography,
      ...(newHeading && { heading: newHeading }),
      ...(newBody && { body: newBody }),
    },
  } as T;
}
